const getConsolidationFacet = (variant) => {
  const isSunglassesVariant = variant.__typename === "SunglassesVariant";
  const isFrameVariant = variant.__typename === "FrameVariant";
  const isReadyReaderVariant = variant.__typename === "ReadyReaderVariant";
  const getFrameFeature = () => {
    if (isFrameVariant) {
      return variant.variantTypeDetails.frameFeatures;
    }
    if (isSunglassesVariant || isReadyReaderVariant) {
      return variant.variantTypeDetails.maybeFrameFeatures;
    }
    return void 0;
  };
  const getLensFeatures = () => {
    if (isFrameVariant) {
      return variant.variantTypeDetails.lensFeatures;
    }
    if (isSunglassesVariant || isReadyReaderVariant) {
      return variant.variantTypeDetails.maybeLensFeatures;
    }
    return void 0;
  };
  const frameFeatures = getFrameFeature();
  const lensFeatures = getLensFeatures();
  const frameSize = frameFeatures?.size;
  const frameColor = frameFeatures?.color.join(",");
  const lensColor = lensFeatures?.lensColor;
  const consolidationFacet = frameSize ? [frameColor, lensColor].filter(Boolean).join("-") : null;
  return consolidationFacet;
};
export {
  getConsolidationFacet
};
//# sourceMappingURL=get-consolidation-facet.js.map
